import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { api } from '../api';
import { toast } from 'react-toastify';

function Permissions() {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPermissions();
  }, []);

  async function fetchPermissions() {
    setLoading(true);
    try {
      const data = await api.getAdminPermissions();
      setPermissions(data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Failed to load permissions.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Helmet><title>Permissions | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Admin Permissions</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Permissions</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card card-default">
                <div className="card-header">
                  <h2>Available Permissions</h2>
                </div>
                <div className="card-body">
                  {loading ? (
                    <p>Loading permissions...</p>
                  ) : permissions.length === 0 ? (
                    <p>No permissions found.</p>
                  ) : (
                    <ul className="list-group">
                      {permissions.map((permission, index) => (
                        <li key={index} className="list-group-item">{permission}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Permissions;
